module.exports = __webpack_public_path__ + "img/ivf.90ccbd2f.svg";